import { getBaseUrl } from '@/apis/request';

export const getCDNAssets = (fileName: string): string => {
  const baseCDNUrl = 'https://img.mcd.cn/mini/main/images/';
  return `${baseCDNUrl}${encodeURIComponent(fileName)}`;
};

// 性别: 0-未知; 1-male; 2-female;
export type Gende = 1 | 2 | 0;

export const getGendertitle = (gende: Gende) => {
  const genderMap = {
    1: '先生',
    2: '女士',
    0: '',
  };

  return genderMap[gende] || '';
};

export interface LocationInfo {
  latitude: number;
  longitude: number;
}

export const formatPrice = (originalPrice?: number): number => {
  if (!originalPrice) return 0;
  return originalPrice / 100;
};

/**
 *
 * @param str
 * @returns
 */
export const parseObj = <T extends Record<string, any>>(str?: string | null) => {
  if (str && typeof str === 'string') {
    try {
      return JSON.parse(str) as T;
    } catch (error) {
      console.error('[utils] parseObj error: %s', str);
    }
  }

  return undefined;
};

/**
 * 复制文本
 * @param {string} text 复制的文本
 * @param {() => void} onSuccess
 * @param {() => void} onFailure
 */
export const copyText = (text: string, onSuccess?: () => void, onFailure?: () => void) => {
  const input = document.createElement('input');
  document.body.appendChild(input);
  input.setAttribute('readonly', 'readonly');
  input.setAttribute('value', text);
  input.select();
  input.setSelectionRange(0, text.length);
  try {
    document.execCommand('copy');
    onSuccess && onSuccess();
  } catch (err) {
    onFailure && onFailure();
  }
  document.body.removeChild(input);
};

const pointUrlMap = {
  sit: 'https://www-sit.mcdchina.net/integral.html?pointType=0',
  uat: 'https://www-uat.mcdchina.net/integral.html?pointType=0',
  prod: 'https://www.mcd.cn/integral.html?pointType=0',
};

export const getPointUrl = () => {
  let _env = 'prod';
  const apiUrl = getBaseUrl();
  if (/sit/.test(apiUrl)) {
    _env = 'sit';
  }
  if (/uat/.test(apiUrl)) {
    _env = 'uat';
  }
  return pointUrlMap[_env as keyof typeof pointUrlMap];
};
